module.exports = __webpack_public_path__ + "static/why-content-image-3-ca6cf1468c55dd4d2ffa696321d56d4a.svg";